exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-subtitle[data-v-035fbbff]{color:#19d3da!important;font-size:10px;font-weight:700}.v-card__title[data-v-035fbbff]{font-size:28px;line-height:33px;letter-spacing:-.02em;color:#303941}.login-info[data-v-035fbbff],.v-card__title[data-v-035fbbff]{font-family:Karla;font-style:normal;font-weight:700;text-align:center}.login-info[data-v-035fbbff]{font-size:16px;line-height:19px;color:#667085}.theme--light .btn-ver[data-v-035fbbff]{font-family:Karla;font-style:normal;font-weight:300;font-size:14px;line-height:16px;display:flex;align-items:center;text-align:center;text-transform:capitalize}", ""]);

// exports
